import { render } from "./ComponentDynamicForm.vue?vue&type=template&id=35290b8d&scoped=true"
import script from "./ComponentDynamicForm.vue?vue&type=script&lang=js"
export * from "./ComponentDynamicForm.vue?vue&type=script&lang=js"

import "./ComponentDynamicForm.vue?vue&type=style&index=0&id=35290b8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35290b8d"]])

export default __exports__